import { TargetIcon } from "@eisox/icons";
import { Link } from "@tanstack/react-router";

import { Tooltip } from "~/components/tooltip";
import { m } from "~/paraglide/messages";

import { SetpointKind, type SetpointSection } from "../helpers";

interface SetpointLineProps {
  kind: SetpointKind;
  section: SetpointSection;
  /** The second line of a pair wears a faded icon; a line standing alone never does. */
  muted?: boolean;
  buildingId: string;
  airHandlerUnitId: string;
  /** Defaults to the target; the heating and cooling lines carry their own quantity icon instead. */
  icon?: React.ComponentType<{ className?: string; "aria-hidden"?: boolean }>;
  children: React.ReactNode;
}

const SetpointLine: React.FC<SetpointLineProps> = ({
  kind,
  section,
  muted = false,
  buildingId,
  airHandlerUnitId,
  icon: Icon = TargetIcon,
  children,
}) => {
  const label =
    kind === SetpointKind.ACTUAL
      ? m.air_handler_unit_actual_computed_setpoint()
      : m.air_handler_unit_computed_setpoint();

  return (
    <Tooltip position="right" content={label}>
      <Link
        to={"/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint"}
        params={{ buildingId, airHandlerUnitId }}
        search={{ section }}
        className="gap-1 flex items-center"
      >
        <Icon aria-hidden className={muted ? "opacity-55" : undefined} />
        <span className="sr-only">{label}</span>
        {children}
      </Link>
    </Tooltip>
  );
};

SetpointLine.displayName = "SetpointLine";

export { SetpointLine };
export type { SetpointLineProps };
